import { useQuery } from 'react-query'
import request from '../../../request'
import { selectedDealership } from '../../../../store/selectors/dealershipSelector'
import { useSelector } from 'react-redux'
import { useBuildQueryParams } from '../../../../lib/hooks/useBuildQueryParams'
import { useDealership } from '../../../../store/zustand/dealershipStore'

export const useGetSearchCampaignReports = ({
  campaign_id,
  filters,
}: {
  campaign_id?: string | number
  filters?: Record<string, any>
}) => {
  const dealership = useDealership()
  const queryParams = useBuildQueryParams(filters)

  return useQuery<{
    metrics: Array<any>
    overallMetrics: {
      impressions: number
      clicks: number
      click_share: number
      search_impression_share: number
      content_impression_share: number
      content_impression_share_lost_to_budget: number
      content_impression_share_lost_to_rank: number
      search_absolute_top_impression_share: number
      search_impression_share_lost_to_budget: number
      search_impression_share_lost_to_rank: number
      phone_calls: number
      leads: number
      sales: number
      conversions: number
      vendor_id: number
    }
    deviceMetrics: Array<{
      device_name: string
      impressions: number
      clicks: number
    }>
    dayOfWeekData: Array<{
      day_of_week: string
      impressions: number
      clicks: number
    }>
    conversions: Array<{
      date: Date
      id: number
      tag_name: string
      conversions: number
      all_conversions: number
    }>
  }>(
    ['campaigns', campaign_id, 'reports', 'search', { queryParams }],
    ({ signal }) =>
      request({
        url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/campaigns/search/${campaign_id}/metrics`,
        method: 'GET',
        signal,
        params: {
          ...queryParams,
        },
      }).then((res: any) => res.data),
    {
      enabled: !!campaign_id,
      keepPreviousData: true,
    },
  )
}
